<template lang="html">


  <div class="vendor-explore">
    <div class="bumper">

    </div>
    <div class="container">
      <div class="breadcrumb">
        <a href="/">Home</a> <span> / </span>  <span class="active current">Marine Vendor</span>
      </div>
      <div class="jumbotron" v-if="!categoryDetail">
        <h2 class="display-4"><span>Docking ID Maritime Vendors Market</span></h2>
        <p class="lead">{{ $t('temukan') }}</p>
      </div>
      <div class="jumbotron" v-else>
        <h2 class="display-4">Category: <span>{{categoryDetail.name}}</span></h2>
        <p class="lead">{{categoryDetail.description}}</p>
      </div>

      <div id="loader-wrapper" v-if="isFetching">
    		<div id="loader"></div>
    	</div>

      <div v-else>

        <SlideAds />

        <!-- <div class="row">
          <div class="col-lg-12">
            <a href="https://us02web.zoom.us/webinar/register/7015889113791/WN_hAF3V-NoRemGnhBduAiD3g">
              <img src="/images/almarin_webinar.png" alt="Alamarin jet Webinar" style="margin-bottom:20px;">
            </a>
          </div>
        </div> -->

        <div class="row">
          <div class="col-lg-3 side-categories">
            <div class="card">
              <div class="card-header">
                <h3>Filter by City</h3>
              </div>
              <div class="card-body">
                 <select class="custom-select" v-model="filters.city" @change="selectCity()">
                   <option value="all-cities" selected>- All City -</option>
                   <option v-for="(city,i) in cities" :value="city.slug" :key="i" >{{ city.name }}</option>
                 </select>
              </div>
              <div class="desktop-only">

                <div style="cursor:pointer" class="card-header header-categories" v-b-toggle.collapse-1>
                  <h3>Vendor Categories</h3>
                  <span></span>
                </div>
                <b-collapse visible class="list-group list-group-flush" id="collapse-1">
                  <li class="list-group-item">
                    <a @click="selectCategory('all-categories')">All Categories</a>
                  </li>
                  <li class="list-group-item" v-for="(vendorCategory,i) in vendorCategories" :key="i">
                    <a v-if="!account" @click="openModalLogin()">{{ vendorCategory.name }}</a>
                    <a v-else @click="selectCategory(vendorCategory.slug)">{{ vendorCategory.name }}</a>
                  </li>
                </b-collapse>

              </div>

              <div class="mobile-only">


                <div style="cursor:pointer" class="card-header header-categories" v-b-toggle.collapse-2>
                  <h3>Vendor Categories</h3>
                  <span></span>
                </div>
                <b-collapse  class="list-group list-group-flush" id="collapse-2">
                  <li class="list-group-item">
                    <a href="/vendor">All Categories</a>
                  </li>
                  <li class="list-group-item" v-for="(vendorCategory,i) in vendorCategories" :key="i">
                    <a v-if="!account" @click="openModalLogin()">{{ vendorCategory.name }}</a>
                    <a v-else @click="selectCategory(vendorCategory.slug)">{{ vendorCategory.name }}</a>
                  </li>
                </b-collapse>

              </div>

            </div>
            <!-- <div class="desktop-only ads-block">
              <a href="https://www.inamarine-exhibition.net/conference/">
                <img src="/images/Inamarine-2480-x-520.png" alt="INAMARINE 2020">
              </a>
            </div> -->
          </div>
          <div class="col-lg-9">

            <!-- <div class="row">
              <SlideAds />
            </div> -->

            <div class="row">

              <div class="col-lg-12 col-sm-12 cantfind" v-if="vendors.length === 0" style="font-style:italic;">
                <p style="font-weight:bold;">Sorry , We can't find vendor that match your Categories / City.</p>
                <ul>
                  <li>Suggestion :</li>
                  <li>- Find vendor from nearest city.</li>
                  <li>- Select another categories.</li>
                  <li>- Contact us.</li>
                </ul>

              </div>

              <div v-else class="col-lg-4 col-sm-6" v-for="(vendor, i) in vendors" :key="i">
                <a @click="viewProfile(vendor)">
                  <div class="card" :class="!vendor.vendorPackage ? vendor.vendorPackage : 'premium-box'">
                    <div v-if="vendor.vendorPackage" class="crown"></div>
                    <div class="box-img">
                      <img class="card-img-top" :src="vendor.images[0] ? vendor.images[0].image : '/images/shipyard-occupancy.png'" alt="vendor.name">
                      <!-- <b-badge class="vendor_plan" v-if="vendor.vendorPackage">Premium Vendor : <strong>{{vendor.vendorPackage.package.name}}</strong></b-badge> -->
                      <div class="vendor-logo">
                        <img :src="vendor.logo ? vendor.logo : '/images/shipyard-occupancy.png'" alt="vendor.name">
                      </div>
                    </div>
                    <div class="card-body">
                      <h5 class="card-title">{{ vendor.name }}</h5>
                      <span class="contact_email">{{ vendor.email }}</span>
                      <p class="city"><i></i><span>{{ vendor.vendorCities[0].city !== null ? vendor.vendorCities[0].city.name : "" }}</span> </p>

                      <b-badge style="background-color: #152734; color:#fff;" >{{ vendor.vendorServices[0].service !== null ? vendor.vendorServices[0].service.name : ""}}</b-badge>

                    </div>
                </div>
                </a>
              </div>

              <div class="col-log-12 col-sm-12" id="loader-wrapper" v-if="isFetchingMore">
                <div id="loader"></div>
              </div>

            </div>

            <!-- <div class="mobile-only row">
              <div class="ads-block">
                <a href="https://www.inamarine-exhibition.net/conference/">
                  <img src="/images/Inamarine-2480-x-520.png" alt="INAMARINE 2020">
                </a>
              </div>
            </div> -->

            <div v-if="showMoreBtn" class="row">
              <div class="col-lg-3"></div>
              <div class="col-lg-9">
                <div class="btn btn-primary more-vendors" @click="() => {
                  isFetchingMore = true
                  currentPage += 1
                  getVendors()
                }">
                  Load More Vendor
                  <div class="right-icon">

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <ModalFiber v-if="fiberVendor" :fiberDetail="fiberVendor" :hideMessageForm="true"/>
    </div>

    <!-- <div v-if="categoryDetail" class="seo-text">
      <div class="container">
        <p{{categoryDetail.footerText}}></p>
      </div>
    </div> -->
    <div style="display:none" class="jumbotron" v-if="!categoryDetail">
      <h2 class="display-4"><span>Docking ID Maritime Vendors Market</span></h2>
      <p class="lead">{{ $t('temukan') }}</p>
    </div>
    <div class="seo-text" v-else>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <p class="lead">{{categoryDetail.footerText}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

import VendorAPI from "~/api/vendors.js"
import VendorCategoryAPI from "~/api/vendor_categories.js"
import MiscAPI from "~/api/misc.js"
import SlideAds from '~/components/slide-ads'
import ModalFiber from '~/components/modal/fiber-popup'
import Cookie from 'js-cookie'
import accountAPI from '~/api/account.js'

export default {
  components : {
    SlideAds,
    ModalFiber,
    SlideAds
  },
  data:function() {
    return {
      isFetching:true,
      isFetchingMore:false,
      vendors:[],
      vendorCategories:[],
      cities:[],
      currentPage:1,
      limit:9,
      showMoreBtn: false,
      filters:{
        city: this.$route.params.city || null,
        category: this.$route.params.category || null
      },
      fiberVendor: null,
      categoryDetail: null
    }
  },
  head() {
    return {
      title: 'DOCKING.ID | Explore Marine Vendors',
      meta: [
        { name: 'description', hid: 'description', content: 'Daftar Marine Vendor Indonesia, Direktori Vendor Maritim Indonesia,  Indonesia Marine Vendor Directory' },
        { name: 'keywords', hid: 'keywords',  content: 'Cari Marine Equipment, Daftar Marine Vendors Indonesia, List Marine Vendors, Data Marine Vendors Indonesia, Portal Marine Vendors Indonesia, Bungker & Provision, Mooring, Marine Equipment, PINDAD' },
        // Open Graph
        { property: 'og:title', content: 'DOCKING.ID | Explore Marine Vendors' },
        { property: 'og:description', content: 'Cari Marine Equipment, Daftar Marine Vendor Indonesia, Direktori Vendor Maritim Indonesia, Indonesia Marine Vendor Directory' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://www.docking.id/vendor' },
        { property: 'og:image', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png' },
        // Twitter Card
        { name: 'twitter:card', content: 'DOCKING.ID | Explore Marine Vendors' },
        { name: 'twitter:site', content: 'https://www.docking.id/vendor' },
        { name: 'twitter:title', content: 'DOCKING.ID | Explore Marine Vendors'},
        { name: 'twitter:description', content: 'Cari Marine Equipment, Daftar Marine Vendor Indonesia, Direktori Vendor Maritim Indonesia, Indonesia Marine Vendor Directory'},
        { name: 'twitter:image', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png' },
        { name: 'twitter:image:alt', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png'}
      ]
    }
  },
  computed: {
		account() {
			let data = this.$store.state.account.account;

			if(data && data.type == 'user') data.detail = data.user;
			else if(data && data.type == 'shipyard') data.detail = data.shipyard;
			else if(data && data.type == 'vendor') data.detail = data.vendor;

			return data;
		},
		lang() {
			return this.$store.state.lang.locale
		}
	},
  methods:{
		openFiberPopup() {
			this.$root.$emit('bv::show::modal','ModalFiber')
		},
		closeFiberPopup() {
			this.$root.$emit('bv::hide::modal','ModalFiber')
		},
    openModalLogin() {
			this.$root.$emit('bv::show::modal','modalLogin')
		},
		viewProfile(vendor) {
			// if(vendor.vendorPackage) {
			// 	if(vendor.vendorPackage.package.name.toLowerCase() == 'fiber') {
      //     this.fiberVendor = vendor;
      //     this.fiberVendor.type = 'vendor';
			// 		setTimeout(() => {
			// 			this.openFiberPopup();
			// 		}, 200)
			// 	} else {
			// 		this.goToDetail(vendor.slug)
			// 	}
			// }
      this.goToDetail(vendor.slug)
		},
		goToDetail(slug) {
			if(Cookie.get('DOCKSID')) {
				window.location.pathname = '/vendor/profile/' + slug;
			}else {
				this.$root.$emit('bv::show::modal','modalLogin');
			}
		},
    getVendors(){
      let vendorApi = new VendorAPI(this.$axios)
      let _this = this

      let params = {
        "limit" : this.limit,
        "page" : this.currentPage,
        "has_active" : 1,
        "order_by" : "package"
      }

      if(this.filters.category && !this.filters.category.includes('all-')) params.vendor_service = this.filters.category;
      if(this.filters.city && !this.filters.city.includes('all-')) params.city = this.filters.city;

      vendorApi.getAll(params).then(res => {
          res.data.data.forEach(element => {
            _this.vendors.push( element )
          });

          _this.showMoreBtn = res.data.meta.totalPage > _this.currentPage ? true : false;

          _this.isFetching = false;
          _this.isFetchingMore = false;
      })
    },
    getVendorCategories(){
      let vendorCategoryApi = new VendorCategoryAPI(this.$axios)
      let _this = this

      vendorCategoryApi.getAll().then(res => {
        res.data.forEach(item => {
          _this.vendorCategories.push(item)
        });
      })
    },
    getCities() {

      let MiscApi = new MiscAPI(this.$axios)
      let _this = this

      MiscApi.getCities()
      .then(res => {
        _this.cities = res.data.data
      })
    },
    getVendorCategory(id) {

      let vendorCategoryApi = new VendorCategoryAPI(this.$axios)
      let _this = this

      vendorCategoryApi.getDetail(id)
      .then(res => {
        _this.categoryDetail = res.data;
      })
    },
    selectCity() {
      let category = this.filters.category ? this.filters.category : 'all-categories';
      let _path = '/vendor/' + this.filters.city + '/' + category;

      this.$router.push({
        path: _path
      })
    },
    selectCategory(category) {
       let city = this.filters.city ? this.filters.city : 'all-cities';
       let _path = '/vendor/' + city + '/' + category;

       this.$router.push({
         path: _path
       })
    }
  },
  beforeMount(){
    this.getVendorCategories()
    this.getVendors()
    this.getCities()
    if(this.$route.params.category && !this.$route.params.category.includes('all-')) this.getVendorCategory(this.$route.params.category);
  }
}
</script>

<style lang="scss">
	@import '~/assets/scss/_mixins.scss';
	@import './style.scss';
</style>
